import { FileDownloader } from "../types/file-downloader";
import { Observable } from 'rxjs';
import { UrlBuilderService } from "@feature/common";
import { HttpClient } from '@angular/common/http';

/**
 * Implementation of `FileDownloader` which gets an observable of a blob of file data for
 * noticeboard file attachments.
 */
export class NoticeboardFileDownloadService implements FileDownloader {

    getFileDownload() : Observable<Blob> {
      const url = this.urlBuilder.getUrl('download-notification-attachment');
      return this.http.post(url, this.uri, { responseType: 'blob' });
    }

  constructor(private readonly urlBuilder : UrlBuilderService,
              private readonly http : HttpClient,
              private readonly uri : number) { }
}
